<div class="detail-content__description">
    <div class="description" [innerHTML]="_api(projection?.translations, 'description')"></div>
</div>
